import { render, staticRenderFns } from "./BannersPPOB.vue?vue&type=template&id=522712f6"
import script from "./BannersPPOB.vue?vue&type=script&lang=js"
export * from "./BannersPPOB.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports